module.exports = __webpack_public_path__ + "static/media/claudia_miranda_c.8644d8b9.jpg";